export const trimString = (string: string, length: number) => {
  if (string?.length <= length) return string

  const trimmedString = string?.slice(0, length)?.trim();
  return `${trimmedString}...`
}

export const formatDecimal = (value) => {
  if (value === null || value === undefined || value === '') {
    return '0.000'
  }
  return Number(value).toFixed(3)
}
